import { AlertCircle } from 'lucide-react';

export default function ErrorBanner({ message }) {
  if (!message) return null;
  return (
    <div className="rounded-lg border border-rose-900/60 bg-rose-950/40 px-4 py-3 flex items-start gap-3">
      <AlertCircle className="text-rose-400 mt-0.5 shrink-0" size={18} />
      <div className="text-sm text-rose-200">{message}</div>
    </div>
  );
}
